(function () {
  function initRitualCollapsibleRows() {
    const root = document.querySelector(".ritual-product-description");
    if (!root) return;

    if (root.classList.contains("collapsible-ready")) return;
    root.classList.add("collapsible-ready");

    const headings = Array.from(root.querySelectorAll("h3"));
    if (!headings.length) return;

    headings.forEach((heading, index) => {
      const content = document.createElement("div");
      content.className = "ritual-collapsible-content";

      let next = heading.nextSibling;
      while (next && !(next.nodeType === 1 && next.tagName === "H3")) {
        const temp = next.nextSibling;
        content.appendChild(next);
        next = temp;
      }

      heading.after(content);
      content.style.overflow = "hidden";
      content.style.maxHeight = "0px";

      heading.addEventListener("click", () => {
        const isOpen = heading.classList.contains("is-open");

        if (isOpen) {
          heading.classList.remove("is-open");
          content.style.maxHeight = "0px";
        } else {
          heading.classList.add("is-open");
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });

    });
  }

  // Storefront
  document.addEventListener("DOMContentLoaded", initRitualCollapsibleRows);
  window.addEventListener("load", initRitualCollapsibleRows);

  // Theme editor
  document.addEventListener("shopify:section:load", initRitualCollapsibleRows);
})();
